<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('companies') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="toolbar">
			<button id="table_toolbar_add" @click="createCompany" :uk-tooltip="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="row">
				<div class="table-footer">
					<div class="col-xs-6 col-sm-3">
						<div id="status-bar" class="status-bar"></div>
					</div>
					<div class="col-xs-12 col-sm-6">
						<div id="pager" class="pager"></div>
					</div>
					<div class="col-sm-3">
						<div id="pagerSize" class="page-sizer-container"></div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('edit.company') }}</a></li>
				<li><a tabindex="-1">{{ $t('edit.users') }}</a></li>
				<li><a tabindex="-1">{{ $t('edit.groups') }}</a></li>
				<li><a tabindex="-1">{{ $t('edit.notifications') }}</a></li>
				<li><a tabindex="-1">{{ $t('edit.attributes') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { resizeTableHeight, Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { bindResetButton } from '@/core/input_controls/button/button'
import { removeTabindex } from '@/core/shared'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'

export default {
	name: 'Companies',
	metaInfo () {
		return {
			title: this.$t('companies')
		}
	},
	methods: {
		createCompany: function () {
			location.href = '/company-create'
		}
	},
	mounted () {
		let tableColumns = [
			{
				'title': 'company.gln',
				'attribute': 'gln',
				'columnName': 'gln'
			},
			{
				'title': 'name',
				'attribute': 'name',
				'columnName': 'name'
			},
			{
				'title': 'description',
				'attribute': 'description',
				'columnName': 'description'
			},
			{
				'title': 'value.added.tax',
				'attribute': 'valueAddedTax',
				'columnName': 'valueAddedTax'
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' }
		}

		this.$store.dispatch(USER_CONFIG, 'companiesTable.tableState')
			.then((config) => {
				window.table = new Table("companiesTable", {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: "#context-menu",
						doubleClickMode: "edit",
						sortingSupport: true,
						cellsSelectionsSupport: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {};
							for (var fieldName in filter)
								newFilter[fieldName] = filter[fieldName]['val'];
							return newFilter;
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								location.href = '/company/' + item.id + '?activeAttribute=' + attribute;
							},
							2: function (item) {
								location.href = '/company/' + item.id + '/users';
							},
							3: function (item) {
								location.href = '/company/' + item.id + '/groups';
							},
							4: function (item) {
								location.href = '/company/' + item.id + '/notifications';
							},
							5: function (item) {
								location.href = '/company/' + item.id + '/attributes';
							}
						},
						doubleClick: {
							"edit": function(item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute);
							}
						}
					}
				);
				table.setSavedState(config);
				table.setDataUrl(window.urlContext + 'companies/load');
				table.setDataIDsUrl(window.urlContext + 'companies/ids');
				table.setDataSortUrl(window.urlContext + 'companies/sort');
				table.initTable();

				bindResetButton();
				removeTabindex();

				setToolbarMode(table.selectedItemsMode);
				initFilterForm(itemStructure, table);
				enableHotkeyForSearch(itemStructure, table);
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG companiesTable', error)
			})



		$("#table_toolbar_search").bind("click", toggleSearchForm);

		$(window).resize(function() {
			resizeTableHeight();
			table.frozenTableElements.setFrozenHeaderCellsWidth();
			table.frozenTableElements.setFrozenColumnCellsHeight();
		});
	}
}
</script>

<style scoped>

</style>
